module.exports = __webpack_public_path__ + "static/media/step11.99a869d0.png";